import React from "react";
import { Link } from "react-router-dom";
import { FaHome, FaSearch } from "react-icons/fa";
import { Helmet } from "react-helmet-async";
import { SEO_CONSTANTS } from "../common/SEOConstants";

const NotFound = () => {
  return (
    <section className="not-found-page">
      <Helmet>
        <title>Page Not Found - Pathshala Sanchalak</title>
        <meta
          name="description"
          content="The page you were looking for couldn't be found. Navigate back to our homepage or explore our blog for educational content."
        />
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href={`${SEO_CONSTANTS.SITE_URL}/404`} />
      </Helmet>

      <div className="container">
        <div className="not-found-content">
          <h1>404</h1>
          <h2>Page Not Found</h2>
          <p>The page you are looking for doesn't exist or has been moved.</p>

          <div className="not-found-actions">
            <Link to="/" className="btn btn-primary">
              <FaHome /> Back to Homepage
            </Link>
            <Link to="/blog" className="btn btn-outline">
              <FaSearch /> Browse Blog
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NotFound;
